var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167.643,
    height: 176.163,
    viewBox: "0 0 167.643 176.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.66,
    y1: 1,
    x2: -0.152,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D8291C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A41A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.959,
    y1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6631B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4981A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-428.139 -9307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14683",
    "data-name": "Path 14683",
    d: "M4.7,42.3V67.466H38.256C38.256,53.566,25,42.3,8.642,42.3Z",
    transform: "translate(440.215 9415.697)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37471",
    "data-name": "Path 37471",
    d: "M97.45,84.2a8.954,8.954,0,0,0,3.777-2.713,25.024,25.024,0,0,1-4.673,7.11,67.838,67.838,0,0,1-9.732,8.63,33.91,33.91,0,0,1-12.18,4.864,46.632,46.632,0,0,1-8.71,1.356l-.011-.021a11.6,11.6,0,0,1-.832-6.988,10.182,10.182,0,0,1,4.127-7.311,26.928,26.928,0,0,1,13.828-6.151,22.577,22.577,0,0,1,5.828.869,24.063,24.063,0,0,0,5.489.874A8.761,8.761,0,0,0,97.45,84.2M34.177,102.06A33.974,33.974,0,0,1,21.992,97.2a70.028,70.028,0,0,1-9.754-8.652,24.265,24.265,0,0,1-4.673-7.11,8.714,8.714,0,0,0,3.777,2.713c2.76,1.012,5.679.328,8.572-.36a22.9,22.9,0,0,1,5.828-.864A27.375,27.375,0,0,1,39.57,89.069,10.405,10.405,0,0,1,43.7,96.386a11.5,11.5,0,0,1-.8,7.041l.011.021a42.772,42.772,0,0,1-8.736-1.388M16.651,0l3.036,3.528A76.557,76.557,0,0,0,77.843,30.087h17a24.649,24.649,0,0,1,25,23.984v.2a24.336,24.336,0,0,1-12.169,20.773,84.8,84.8,0,0,0-.583-31.115h.005c-.1-.826-.223-1.589-.318-2.215-.032-.265-.45-.2-.45.069.064,2.877,1.091,7.11-.477,9.754-2.368,3.936-7.3-.1-9.637-2.05a23.97,23.97,0,0,0-14.834-7.873A23.9,23.9,0,0,0,65.43,49.033a27.816,27.816,0,0,0-6.3,6.781,9.18,9.18,0,0,1-3.1,4.265,5.893,5.893,0,0,1-1.589.63,5.962,5.962,0,0,1-1.589-.63,9.6,9.6,0,0,1-3.1-4.265,28.142,28.142,0,0,0-6.31-6.781,24,24,0,0,0-15.936-7.417,24.116,24.116,0,0,0-14.834,7.873c-2.331,1.955-7.269,5.987-9.632,2.05-1.595-2.649-.535-6.887-.477-9.754,0-.265-.424-.334-.456-.069-.1.662-.191,1.425-.318,2.215A83.967,83.967,0,0,0,0,60.789v.641A84.33,84.33,0,0,0,7.47,95.819a60.471,60.471,0,0,0,6.713,12.074,33,33,0,0,0,8.683,7.8c6.66,4.265,14.214,6.781,20.805,11.21a61.67,61.67,0,0,1,6.018,5,6.811,6.811,0,0,0,9.478,0,61.669,61.669,0,0,1,6.018-5c4.376-2.919,9.165-5.017,13.844-7.348l25.759,30.055a76.59,76.59,0,0,0,57.928,26.548h4.927l-22.765-26.548L109.625,108.5l-1.319-1.547a54.605,54.605,0,0,0,6.045-1.8A55.172,55.172,0,0,0,144.766,78.42a53.313,53.313,0,0,0,0-48.338A55.528,55.528,0,0,0,95.533,0Z",
    transform: "translate(428.139 9307)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskLogo);
export default __webpack_public_path__ + "static/media/mask-logo.d239e0493db00ff72e5a9932546d2854.svg";
export { ForwardRef as ReactComponent };